import { ContentBox } from 'common/components/AppLayout/ContentBox';
import { SuspenseLoadingView } from 'common/components/SuspenseLoadingView';
import { TableSkeleton } from 'common/components/Table/TableSkeleton';
import { useParams } from 'react-router';
import { SessionHistoryTableWithInterims } from './SessionHistoryTableWithInterims';
import { SessionHistoryErrorBoundary } from './SessionHistoryErrorBoundary';
import { styled } from '@mui/material/styles';

const SessionHistoryWithInterimsRoot = styled('div', { name: 'SessionHistoryWithInterimsRoot' })({
  position: 'relative',
});

export const SessionHistoryWithInterims = () => {
  const { iccid } = useParams();

  return (
    <SessionHistoryWithInterimsRoot>
      <SessionHistoryErrorBoundary>
        <SuspenseLoadingView
          queryKey={['SimInventoryEntry', iccid]}
          loadFallback={
            <ContentBox>
              <TableSkeleton numberOfRows={20} pagination={false} />
            </ContentBox>
          }
        >
          <SessionHistoryTableWithInterims />
        </SuspenseLoadingView>
      </SessionHistoryErrorBoundary>
    </SessionHistoryWithInterimsRoot>
  );
};
